// src/components/DriverStatusChip.js
import React from 'react';
import { Chip } from '@mui/material';

const DriverStatusChip = ({ status }) => {
  let chipColor = 'default';
  let textColor = 'inherit';

  switch (status) {
    case 0: // New
      chipColor = '#ff9800'; // Orange
      textColor = 'white';
      break;
    case 10: // Registering
      chipColor = '#2196f3'; // Blue
      textColor = 'white';
      break;
    case 15: // Pending for review
      chipColor = '#ff9800'; // Orange
      textColor = 'white';
      break;
    case 30: // Valid
      chipColor = '#4caf50'; // Green
      textColor = 'white';
      break;
    case 50: // Alert
      chipColor = '#f44336'; // Red
      textColor = 'white';
      break;
    case 'unknown': // Unknown status
      chipColor = '#607d8b'; // Blue Grey
      textColor = 'white';
      break;
    default:
      chipColor = '#757575'; // Medium grey
      textColor = 'black';
  }

  const statusTextMap = {
    0: 'New',
    10: 'Registering',
    15: 'Review',
    30: 'Valid',
    50: 'Alert',
    'unknown': 'Unknown',
  };

  return (
    <Chip
      label={statusTextMap[status] || 'Unknown'}
      size="small"
      sx={{
        backgroundColor: chipColor,
        color: textColor,
        fontWeight: 'bold',
        height: '16px',
        '& .MuiChip-label': {
          fontSize: '0.65rem',
          px: 0.5,
          py: 0,
        },
      }}
    />
  );
};

export default DriverStatusChip;
